/** @format **/

export enum SocialButtonType {
  Github = 'GitHub',
  GooglePlus = 'GooglePlus',
  Twitter = 'Twitter',
  Facebook = 'Facebook',
}
